/* eslint-disable prefer-rest-params */
/* eslint-disable no-shadow */
/* eslint-disable no-var */
/* eslint-disable one-var */
/* eslint-disable func-names */
/* eslint-disable no-param-reassign */

import isClient from 'commons/isClient';
import getEnvValue from 'commons/getEnvValue';
import scheduleIdleAfterLCP from 'commons/scheduleIdleAfterLCP';

const SCRIPT_ID = 'affirmScript';

export const AFFIRM_LOAD_STRATEGY = {
  IMMEDIATE: 'immediate',
  IDLE_AFTER_LCP: 'idleAfterLcp',
};

let cancelDeferredLoad = null;
let isDeferredScheduled = false;
let isInjecting = false;
const pendingCallbacks = [];

const queueCallback = cb => {
  if (cb) {
    pendingCallbacks.push(cb);
  }
};

const flushCallbacks = () => {
  while (pendingCallbacks.length) {
    pendingCallbacks.shift()?.();
  }
};

const cancelDeferredSchedule = () => {
  cancelDeferredLoad?.();
  cancelDeferredLoad = null;
  isDeferredScheduled = false;
};

const injectAffirmScript = () => {
  if (!isClient() || document.getElementById(SCRIPT_ID) || isInjecting) {
    return;
  }

  isInjecting = true;

  const isSb = window?.location?.search?.indexOf('jb_sb=1') >= 0;

  const affirm_config = {
    public_api_key: !isSb
      ? getEnvValue('NEXT_PUBLIC_AFFIRM_PUB_KEY') ??
        getEnvValue('REACT_APP_AFFIRM_PUB_KEY')
      : getEnvValue('NEXT_PUBLIC_AFFIRM_PUB_KEY_SANDBOX') ??
        getEnvValue('REACT_APP_AFFIRM_PUB_KEY_SANDBOX'),
    script: !isSb
      ? getEnvValue('NEXT_PUBLIC_AFFIRM_SCRIPT_URL') ??
        getEnvValue('REACT_APP_AFFIRM_SCRIPT_URL')
      : getEnvValue('NEXT_PUBLIC_AFFIRM_SCRIPT_URL_SANDBOX') ??
        getEnvValue('REACT_APP_AFFIRM_SCRIPT_URL_SANDBOX'),
  };

  (function(l, g, m, e, a, f, b) {
    var d,
      c = l[m] || {},
      h = document.createElement(f),
      n = document.getElementsByTagName(f)[0],
      k = function(a, b, c) {
        return function() {
          a[b]._.push([c, arguments]);
        };
      };
    c[e] = k(c, e, 'set');
    d = c[e];
    c[a] = {};
    c[a]._ = [];
    d._ = [];
    c[a][b] = k(c, a, b);
    a = 0;
    for (
      b = 'set add save post open empty reset on off trigger ready setProduct'.split(
        ' '
      );
      a < b.length;
      a++
    )
      d[b[a]] = k(c, e, b[a]);
    a = 0;
    for (b = ['get', 'token', 'url', 'items']; a < b.length; a++)
      d[b[a]] = function() {};
    h.async = !0;
    h.id = SCRIPT_ID;
    h.onload = () => {
      isInjecting = false;
      flushCallbacks();
    };
    h.src = g[f];
    n.parentNode.insertBefore(h, n);
    delete g[f];
    d(g);
    l[m] = c;
  })(window, affirm_config, 'affirm', 'checkout', 'ui', 'script', 'ready');
};

const loadAffirmScript = (
  cb,
  { loadStrategy = AFFIRM_LOAD_STRATEGY.IMMEDIATE } = {}
) => {
  if (!isClient()) return;

  if (document.getElementById(SCRIPT_ID)) {
    queueCallback(cb);
    flushCallbacks();
    return;
  }

  queueCallback(cb);

  if (loadStrategy === AFFIRM_LOAD_STRATEGY.IMMEDIATE) {
    cancelDeferredSchedule();
    injectAffirmScript();
    return;
  }

  if (isDeferredScheduled || isInjecting) {
    return;
  }

  isDeferredScheduled = true;

  cancelDeferredLoad = scheduleIdleAfterLCP(() => {
    isDeferredScheduled = false;
    injectAffirmScript();
  });
};

export const isAffirmScriptLoaded = () =>
  isClient() && !!document.getElementById(SCRIPT_ID);

export default loadAffirmScript;
